var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8VisualStudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "~jm6wMmI3aADOIa51_ZGPa",
    x1: 37.672,
    x2: 37.672,
    y1: 3.68,
    y2: 44.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c391f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b579f4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#~jm6wMmI3aADOIa51_ZGPa)",
    d: "M44,10.781v26.403c0,1.147-0.653,2.193-1.684,2.696c-2.348,1.144-6.392,3.113-7.05,3.413 C34.33,43.721,33.742,44,33.007,44s-1.221-0.479-1.559-0.836C31.11,42.806,34,33,34,33V6.23c0,0-3.182-0.666-2.58-1.337 c0.603-0.671,1.107-0.899,1.736-0.899c0.725,0,1.311,0.323,1.971,0.641c0.468,0.225,4.732,2.271,7.174,3.443 C43.342,8.577,44,9.627,44,10.781z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "~jm6wMmI3aADOIa51_ZGPb",
    x1: 4.598,
    x2: 37.92,
    y1: 38.164,
    y2: 4.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#742fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#702db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#5d2596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5d2596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5d2596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#60279a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#6f2dab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#7932b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7e34bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#8035bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#7d34bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#7530ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#66299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#52207d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#481b6e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#~jm6wMmI3aADOIa51_ZGPb)",
    d: "M4,32c0,1.928,0.261,2.214,2.134,3.028C7.59,35.661,8.17,36,8.559,36 c0.469,0,0.91-0.323,1.327-0.664S34,15.525,34,15.525V5.546c0-1.198-1.674-1.676-2.467-0.778c0,0-24.791,27.531-25.533,28.244 S5.767,31.119,4,32z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "~jm6wMmI3aADOIa51_ZGPc",
    x1: 4.405,
    x2: 35.886,
    y1: 25.413,
    y2: 30.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#9c55d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#9c55d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#9751d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#8847cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#8343c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8042c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#773db6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#68369f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643499"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#~jm6wMmI3aADOIa51_ZGPc)",
    d: "M4.62,13.681c0.317-0.152,2.934-1.322,3.256-1.463C8.254,12.053,8.39,12,8.669,12 c0.308,0,0.518,0.117,1.001,0.514C10.345,13.068,34,32.483,34,32.483v9.759c0,1.675-1.744,1.847-2.728,0.741 C30.574,42.199,6.389,15.434,6.389,15.434S4,16.641,4,15.587C4,14.166,4.276,13.847,4.62,13.681z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "~jm6wMmI3aADOIa51_ZGPd",
    x1: 6.5,
    x2: 6.5,
    y1: 34.157,
    y2: 14.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c1d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#561b90"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#~jm6wMmI3aADOIa51_ZGPd)",
    d: "M9,18.323v11.412c0,0-2.73,2.999-3.34,3.659C5.118,33.981,4,33.797,4,32.148v-16.72 c0-1.251,1.131-1.378,2.098-0.323C6.273,15.296,9,18.323,9,18.323z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VisualStudio);
export default __webpack_public_path__ + "static/media/icons8-visual-studio.9c4a484be233d80dd10d4f2730276265.svg";
export { ForwardRef as ReactComponent };